import type { AdjustmentReasonCode } from '../../../services/inventoryApi';
export interface InventoryItem {
  id: string;
  sku: string;
  barcode?: string | null;
  category: string;
  totalQuantity: number;
  reserved: number;
  available: number;
  location: string;
}

export interface AdjustmentForm {
  skuId: string;   // skus.id as string ('' = none)
  lotId: string;   // inventory_lots.id as string ('' = none) — adjustments target a lot
  adjustmentType: string;
  quantity: string;
  reason: string;
  notes: string;
}

export const defaultAdjustmentForm: AdjustmentForm = {
  skuId: '',
  lotId: '',
  adjustmentType: '',
  quantity: '',
  reason: '',
  notes: '',
};

export const adjustmentTypeOptions = ['Select Type', 'Add', 'Remove', 'Damage'];
export const reasonOptions = ['Select Reason', 'Received Shipment', 'Damaged Goods', 'Customer Return', 'Cycle Count', 'Transfer'];



/** Map a UI reason to a backend reason_code. */
export const reasonToCode: Record<string, AdjustmentReasonCode> = {
  'Received Shipment': 'CORRECTION',
  'Damaged Goods': 'DAMAGE',
  'Customer Return': 'CORRECTION',
  'Cycle Count': 'MISCOUNT',
  'Transfer': 'CORRECTION',
};

/** True when the adjustment should DECREASE the lot quantity. */
export function isOutboundAdjustment(adjustmentType: string, reason: string): boolean {
  if (adjustmentType === 'Add') return false;
  if (adjustmentType === 'Remove' || adjustmentType === 'Damage') return true;
  // Fall back to reason intent when type is unset.
  return reason === 'Damaged Goods' || reason === 'Transfer';
}
